// extracted by mini-css-extract-plugin
module.exports = {"connectivity":"CellConnectivity_connectivity__MxCyj","icon":"CellConnectivity_icon__IKT1L","row":"CellConnectivity_row__AWpGT","tableRow":"CellConnectivity_tableRow__ol9Qz"};